import { ChangeDetectorRef, Directive, effect, inject, input } from '@angular/core';
import { getState } from '@ngrx/signals';
import { AdvancedCommerceListingStore } from '../../../store/advanced-commerce-listing.store';
import { AdvancedCommerceStore } from '../../../store/advanced-commerce-store.namespace';

@Directive()
export class AdvancedCommerceListingFiltersAttributeComponentDef {
    filter = input.required<AdvancedCommerceStore.Filters.Filter>();

    readonly store = inject(AdvancedCommerceListingStore);
    protected changeDetectorRef = inject(ChangeDetectorRef);

    constructor() {
        // hack for detect changes in signals store
        effect(() => {
            // read store changes and update template
            const _state = getState(this.store);

            this.changeDetectorRef.detectChanges();
        });
    }

    pickOption(option: AdvancedCommerceStore.Filters.Option): void {
        if (option.selected) {
            this.store.filtersOptionUnselect(this.filter(), option);
        } else {
            this.store.filtersOptionSelect(this.filter(), option);
        }
    }
}
